import type { ReactNode } from "react";

export interface RankingRow {
  key: string;
  label: string;
  detail?: string;
  value: string;
  secondary?: string;
}

export function RankingTable({
  title,
  rows,
  empty = "No data for this period.",
  aside,
}: {
  title: string;
  rows: RankingRow[];
  empty?: string;
  aside?: ReactNode;
}) {
  return (
    <section className="ranking-section">
      <div className="section-heading">
        <h3>{title}</h3>
        {aside}
      </div>
      {rows.length === 0 ? (
        <p className="empty-copy">{empty}</p>
      ) : (
        <ol className="ranking-list">
          {rows.map((row, index) => (
            <li key={row.key}>
              <span className="rank">{String(index + 1).padStart(2, "0")}</span>
              <span className="rank-label">
                <strong>{row.label}</strong>
                {row.detail ? <small>{row.detail}</small> : null}
              </span>
              <span className="rank-value">
                <strong>{row.value}</strong>
                {row.secondary ? <small>{row.secondary}</small> : null}
              </span>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
